<template>
  <div class="section-home-rating home-rating-wrapper">
    <div class="section-container">
      <div class="content-wrapper">
        <div class="content-container">
          <div class="amzn-rating-container">
            <img
              class="img-amzn-choice"
              src="/media/img/home/amzn_choice.png"
              alt="icon_amazon_rating">
            <div class="rating-desc">
              <span>{{ $t('home.blockContent_3.ratingTitle') }}</span>
              <span class="text-bold">{{ $t('home.blockContent_3.star') }}</span>
            </div>
          </div>
          <div class="icon-item-list-wrapper">
            <ul class="icon-item-list">
              <li class="icon-item">
                <img src="/media/img/home/icon_easy_return.png" alt="icon_money_back">
                <span class="icon-text">{{ $t('home.blockContent_3.iconName_easyReturn') }}</span>
              </li>
              <li class="icon-item">
                <img src="/media/img/home/icon_free_shipping.png" alt="icon_free_shipping">
                <span class="icon-text">{{ $t('home.blockContent_3.iconName_freeShipping') }}</span>
                <span class="icon-text icon-text-note">
                  ({{ $t('home.blockContent_3.iconName_freeShipping_note') }})
                </span>
              </li>
              <li class="icon-item">
                <img src="/media/img/home/icon_warranty.png" alt="icon_warranty">
                <span class="icon-text">{{ $t('home.blockContent_3.iconName_warranty') }}</span>
              </li>
            </ul>
          </div>
          <div class="text-content-desc-sm text-content-desc-rating">
            {{ $t('home.blockContent_3.desc') }}
          </div>
          <a
            class="btn btn-learn-more"
            href="/product/camera">{{ $t('home.blockContent_3.btnText') }}</a>
        </div>
      </div>
      <div class="img-wrapper">
        <img :src="imgSrc">
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'home-rating',
  computed: {
    imgSrc() {
      if (window.innerWidth <= 480) {
        return '/media/img/home/block_3_w480.jpg';
      }

      if (window.innerWidth <= 960) {
        return '/media/img/home/block_3_w960.jpg';
      }

      return '/media/img/home/block_3_w1200.jpg';
    },
  },
};
</script>
<style lang="sass" scoped>
.home-rating-wrapper
  --content-width: 42vw
  --product-img-wrapper-height: 540px
  --product-img-height: 600px
  --home-text-subtitle: 24px
  --amzn-rating-img-width: 25vw
  --icon-width: 92px
  --icon-desc-font-size: 16px
  --btn-link-font-size: 16px
  width: 100vw
  background-color: $background-primary
  overflow: hidden
  .section-container
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: flex-start
    padding-top: 12vh
    padding-bottom: 0
    .content-wrapper
      width: var(--content-width)
      padding: 0 24px 0 4vw
      z-index: 200
      .content-container
        width: 100%
        display: flex
        flex-direction: column
        align-items: center
        .amzn-rating-container
          width: calc(var(--content-width) * 0.9)
          img
            width: var(--amzn-rating-img-width)
            min-width: 300px
            height: auto
          .rating-desc
            display: flex
            flex-wrap: wrap
            justify-content: center
            font-size: var(--home-text-subtitle)
            text-align: center
            span
              margin: 0 8px
        .icon-item-list-wrapper
          width: 100%
          display: flex
          justify-content: center
          .icon-item-list
            display: flex
            justify-content: center
            margin: calc(var(--icon-width) * 0.5) 0 calc(var(--icon-width) * 0.4) 0
            .icon-item
              display: flex
              flex-direction: column
              width: var(--icon-width)
              margin: 0 calc(var(--icon-width) * 0.2)
              img
                width: var(--icon-width)
                height: var(--icon-width)
              .icon-text
                width: 135%
                font-size: var(--icon-desc-font-size)
              .icon-text-note
                font-size: calc(var(--icon-desc-font-size) * 0.8)
        .text-content-desc-rating
          width: calc(var(--content-width) * 0.8)
          max-width: 540px
          line-height: 1.5
          text-align: center
        .btn-learn-more
          font-size: var(--btn-link-font-size)
          font-weight: 700
          margin: calc(var(--icon-width) * 0.4) 0
    .img-wrapper
      align-self: flex-end
      width: calc(100vw - var(--content-width))
      height: var(--product-img-wrapper-height)
      display: flex
      align-items: flex-end
      position: relative
      overflow: hidden
      img
        position: absolute
        top: 0
        left: 0
        transform: translate(0, 0)
        height: var(--product-img-height)
        width: auto

@media screen and (orientation: portrait)
  .home-rating-wrapper
    --content-width: 90vw
    --product-img-wrapper-height: 740px
    --product-img-height: 740px
    --amzn-rating-img-width: 50vw
    --home-text-subtitle: 42px
    .section-container
      flex-direction: column
      align-items: center
      padding-top: 8vh
      padding-bottom: 4vh
      .content-wrapper
        .content-container
          .amzn-rating-container
            img
              min-width: 240px
          .text-content-desc-rating
            width: calc(var(--content-width) * 0.8)
            max-width: 640px
      .img-wrapper
        align-self: center
        width: 100vw
        height: var(--product-img-wrapper-height)
        img
          left: 52.5%
          transform: translate(-50%, 0)

@media screen and (orientation: landscape) and (min-width: 1600px)
  .home-rating-wrapper
    --home-text-subtitle: 32px
    --content-width: 36vw
    --product-img-wrapper-height: 75vh
    --product-img-height: 85vh
    --icon-width: 100px
    --btn-link-font-size: 18px
    .section-container
      .content-wrapper
        padding: 0 24px 0 8vw

@media screen and (orientation: landscape) and (max-width: 1200px)
  .home-rating-wrapper
    --icon-width: 80px
    --product-img-wrapper-height: 540px
    --product-img-height: 500px

@media screen and (orientation: portrait) and (min-width: 960px)
  .home-rating-wrapper
    --icon-width: 112px
    --icon-desc-font-size: 18px
    --btn-link-font-size: 28px

@media screen and (orientation: portrait) and (max-width: 768px)
  .home-rating-wrapper
    --home-text-subtitle: 32px
    --icon-width: 92px
    --product-img-wrapper-height: 560px
    --product-img-height: 560px
    --icon-desc-font-size: 16px
    --btn-link-font-size: 16px

@media screen and (orientation: portrait) and (max-width: 576px)
  .home-rating-wrapper
    --home-text-subtitle: 24px
    --icon-width: 80px
    --product-img-wrapper-height: 360px
    --product-img-height: 360px
    --icon-desc-font-size: 14px
    --btn-link-font-size: 14px

@media screen and (orientation: portrait) and (max-width: 414px)
  .home-rating-wrapper
    --product-img-wrapper-height: 70vw
    --home-text-subtitle: 24px
    --icon-width: 72px
    --product-img-wrapper-height: 300px
    --product-img-height: 300px
    --icon-desc-font-size: 12px
    --btn-link-font-size: 14px

@media screen and (orientation: portrait) and (max-width: 360px)
  .home-rating-wrapper
    --home-text-subtitle: 20px
    --icon-width: 60px
    --product-img-wrapper-height: 280px
    --product-img-height: 280px
    --icon-desc-font-size: 10px
    --btn-link-font-size: 14px

@media screen and (orientation: portrait) and (max-width: 320px)
  .home-rating-wrapper
    --btn-link-font-size: 12px

</style>
